import { render } from "./PasswordAndConfirmation.vue?vue&type=template&id=47db3d52"
import script from "./PasswordAndConfirmation.vue?vue&type=script&lang=js"
export * from "./PasswordAndConfirmation.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QLinearProgress from 'quasar/src/components/linear-progress/QLinearProgress.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QSlideTransition from 'quasar/src/components/slide-transition/QSlideTransition.js';
import qInstall from "../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QInput,QIcon,QLinearProgress,QSpace,QSlideTransition});
